import {
  ApplicationConfig,
  importProvidersFrom,
  APP_INITIALIZER,
  inject,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';

import { routerOptions, routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { InMemoryDataService } from '../../services/in-memory-data.service';
import { EnvironmentService } from '../../../app/services/environment.service';
import { httpHeaderInterceptor } from '../../interceptors/http-header.interceptor';
import { MessageService } from 'primeng/api';
import { ConfigService } from '../../services/config.service';
import { provideClientHydration } from '@angular/platform-browser';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([httpHeaderInterceptor])),
    importProvidersFrom([
      RouterModule.forRoot(routes, routerOptions), // Enables scroll restoration
    ]),
    provideAnimationsAsync(),
    provideHttpClient(),
    // The HttpClientInMemoryWebApiModule module intercepts HTTP requests
    // and returns simulated server responses.
    // Remove it when a real server is ready to receive requests.
    importProvidersFrom(
      HttpClientInMemoryWebApiModule.forRoot(InMemoryDataService, {
        dataEncapsulation: false,
        rootPath: 'api/',
        passThruUnknownUrl: true,
      }),
    ),
    EnvironmentService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [EnvironmentService],
      multi: true,
    },
    MessageService,
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeConfig,
      deps: [ConfigService],
      multi: true,
    },
    provideClientHydration(),
  ],
};

export function initializeApp(environmentService: EnvironmentService) {
  return (): Promise<void> => {
    return new Promise((resolve) => {
      environmentService.getEnvConfig();
      resolve();
    });
  };
}

export function initializeConfig(configService: ConfigService) {
  const platformId = inject(PLATFORM_ID);
  if (isPlatformBrowser(platformId)) {
    return () => configService.loadConfig();
  } else {
    return () => Promise<void>;
  }
}
